import { render, staticRenderFns } from "./ticketCard.vue?vue&type=template&id=85754bfa&scoped=true&"
import script from "./ticketCard.vue?vue&type=script&lang=js&"
export * from "./ticketCard.vue?vue&type=script&lang=js&"
import style0 from "./ticketCard.vue?vue&type=style&index=0&id=85754bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85754bfa",
  null
  
)

export default component.exports